import { useNavigate } from "react-router-dom";
import APIS from "../../constant/EndPoint";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import SwitchButton from "../Reusable/SwitchButton";
import TableActionButton from "../Reusable/TableActionButton";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";

const VehicleList = ({ handleIsActive }: any) => {
  const navigate = useNavigate();
  const onRowClick = (row: any) => {
    navigate(`edit/${row?.original?.id}`);
  };
  const defaultColumns: any = [
    {
      header: "Emergency Contact Number",
      accessorKey: "emergency_contact_number",
      cell: NACell,
    },

    {
      header: "Vehicle Number",
      accessorKey: "license_number",
      cell: NACell,
    },

    {
      header: "Active",
      accessorKey: "is_active",
      cell: ({ row, getValue }: any) => {
        return (
          <SwitchButton
            id={row?.original?.id}
            value={getValue()}
            onChange={handleIsActive}
          />
        );
      },
    },
  ];
  return (
    <DataTable
      url={APIS.VEHILCE}
      queryKey={"vehicle"}
      columns={defaultColumns}
      addNewPagePath={"create"}
      tableName={"vehicle"}
      onRowClick={onRowClick}
    />
  );
};

export default VehicleList;
